import Icon from "@components/ui/icon";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

const PlaceholderDataNote = () => {
  const navigate = useNavigate();
  const navigateToStories = useCallback(() => {
    navigate("/pages/editor");
  }, [navigate]);
  return (
    <div className="tw-pointer-events-none tw-fixed tw-bottom-4 tw-left-1/2 tw-z-[200] tw-flex tw-w-full -tw-translate-x-1/2 tw-items-center tw-justify-center tw-px-4">
      <div
        style={{
          boxShadow:
            "0px 14px 4px 0px rgba(18, 3, 62, 0.00), 0px 9px 4px 0px rgba(18, 3, 62, 0.01), 0px 5px 3px 0px rgba(18, 3, 62, 0.03), 0px 2px 2px 0px rgba(18, 3, 62, 0.04), 0px 1px 1px 0px rgba(18, 3, 62, 0.05)",
        }}
        className="tw-pointer-events-auto tw-flex tw-w-max tw-items-center tw-gap-2 tw-rounded-lg tw-border tw-border-golden-800/20 tw-bg-golden tw-px-3 tw-py-2 tw-font-sans tw-text-[13px] tw-font-semibold tw-text-blue"
      >
        <Icon icon="sd-warning-triangle" className="tw-shrink-0" />
        <span>
          These are demo analytics. To get yours, start by sharing your first
          story.{" "}
          <span
            className="tw-cursor-pointer tw-underline tw-transition-opacity hover:tw-opacity-70"
            onClick={navigateToStories}
          >
            Go to stories
          </span>
        </span>
      </div>
    </div>
  );
};

export default PlaceholderDataNote;
